"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdInfoPanel = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _ads = require("../../redux/modules/ads");

var _reactRouter = require("react-router");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _NumberUtil = require("../../utils/NumberUtil");

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdInfoPanel = exports.AdInfoPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AdInfoPanel, _Component);

  function AdInfoPanel() {
    (0, _classCallCheck3.default)(this, AdInfoPanel);
    return (0, _possibleConstructorReturn3.default)(this, (AdInfoPanel.__proto__ || (0, _getPrototypeOf2.default)(AdInfoPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(AdInfoPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          ad = _props.ad,
          loadAd = _props.loadAd;

      if (!ad.isLoaded) {
        loadAd(ad.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row notice-info notice-info-panel" },
        this.defineContent()
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      if (this.props.ad.isLoaded) {
        return this.renderAdInfo();
      } else {
        return this.renderSpinner();
      }
    }
  }, {
    key: "renderAdInfo",
    value: function renderAdInfo() {
      var ad = this.props.ad;

      return _react2.default.createElement(
        "div",
        { className: "notice-info-js notice-info-content" },
        ad.project_id > 0 ?
        //        <Route path="/ilmoitukset/:adId//projekti/projectId/muokkaa" component={EditAd} />

        _react2.default.createElement(
          _reactRouter.Link,
          { to: "/ilmoitukset/" + ad.id + "/projekti/" + ad.project_id + "/muokkaa", className: "ad-update-link" },
          "Muokkaa"
        ) : _react2.default.createElement(
          _reactRouter.Link,
          { to: "/ilmoitukset/" + ad.id + "/muokkaa", className: "ad-update-link" },
          "Muokkaa"
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-sm-6" },
          _react2.default.createElement(
            "h4",
            { className: "notice-info-title" },
            "Ilmoituksen tiedot:"
          ),
          _react2.default.createElement(
            "table",
            { className: "notice-info-table" },
            _react2.default.createElement(
              "tbody",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Toimitusaika:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.delivery_time
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Hinta:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  this.getPrice()
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Halutaan tarjous kuljetuksista:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.transfer_request ? "Kyllä" : "Ei"
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Muuta:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.notes
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Ilmoitus j\xE4tetty:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  (0, _moment2.default)(ad.created_at).format("D.M.YYYY")
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Maa-aineksen tarkennus:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.soil_description
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-sm-6" },
          _react2.default.createElement(
            "h4",
            { className: "notice-info-title" },
            "Ty\xF6maan tiedot:"
          ),
          _react2.default.createElement(
            "table",
            { className: "notice-info-table" },
            _react2.default.createElement(
              "tbody",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Rakennuttaja:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.builder
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Urakoitsija:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.contractor
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Osoite:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  (0, _UserUtil.formatAddress)(ad.address, ad.postal_code, ad.postal_area)
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Yhteyshenkil\xF6:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.contact_person_name
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Puhelin:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.contact_person_phone
                )
              ),
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "S\xE4hk\xF6posti:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  ad.contact_person_email
                )
              )
            )
          )
        ),
        "p:",
        ad.project_id,
        " i: ",
        ad.id,
        " t: ",
        ad.user_id
      );
    }
  }, {
    key: "getPrice",
    value: function getPrice() {
      var ad = this.props.ad;

      if (ad.price > 0) {
        return (0, _NumberUtil.formatPrice)(ad.price) + "/t";
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(_Spinner2.default, null)
      );
    }
  }]);
  return AdInfoPanel;
}(_react.Component), _class.propTypes = {
  ad: _react.PropTypes.object.isRequired,
  loadAd: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    ads: state.ads
  };
}, {
  loadAd: _ads.loadAd
})(AdInfoPanel);


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/AdInfoPanel.js
 ** module id = 1146
 ** module chunks = 0
 **/